export default __webpack_public_path__ + "static/media/V220MANE3.85ed23f3.pdf";